import './glow-button.css'

import type { ButtonHTMLAttributes, CSSProperties, ReactNode } from 'react'

import classNames from '../../utils/classNames'

interface GlowButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode | string
  className?: string
  width?: CSSProperties['width']
  variant?: 'green' | 'blue' | 'red'
}

const GlowButton = ({
  children,
  className = '',
  width,
  style = {},
  variant = 'red',
  ...rest
}: GlowButtonProps) => {
  return (
    <button
      className={classNames(
        'flx-ctr text-white font-bold uppercase rounded-md transition-all dark:font-extrabold dark:tracking-[0.02em] disabled:opacity-50 disabled:pointer-events-none',
        variant === 'green' && 'glow-btn-green bg-[#41bc2c]',
        variant === 'blue' && 'glow-btn-blue bg-[#2196F3]',
        variant === 'red' && 'glow-btn-red bg-[#DF0033]',
        className,
      )}
      style={{ width, ...style }}
      {...rest}>
      {children}
    </button>
  )
}

export default GlowButton
